import * as AT from './actionTypes';



export const clear = () => ({
  type: AT.CLEAR,
});

export const update = () => ({
  type: AT.UPDATE,
});

export const setData = (data) => ({
  type: AT.SET_DATA,
  payload: data,
});

export const setMaxSupply = (data) => ({
  type: AT.SET_MAX_SUPPLY,
  payload: data,
});
export const setTotalSupply = (data) => ({
  type: AT.SET_TOTAL_SUPPLY,
  payload: data,
});

export const setTimstamp = (data) => ({
  type: AT.SET_TIMESTAMP,
  payload: data,
});
export const setTimstampPresale = (data) => ({
  type: AT.SET_TIMESTAMP_PRESALE,
  payload: data,
});
export const setTimstampPresaleEnd = (data) => ({
  type: AT.SET_TIMESTAMP_PRESALE_END,
  payload: data,
});
/*export const setTimstampRaffleEnd = (data) => ({
  type: AT.SET_TIMESTAMP_RAFFLE_END,
  payload: data,
});*/
export const setTimstampSale = (data) => ({
  type: AT.SET_TIMESTAMP_SALE,
  payload: data,
});


export const setPricePresale = (data) => ({
  type: AT.SET_PRICE_PRESALE,
  payload: data,
});
export const setPriceSale = (data) => ({
  type: AT.SET_PRICE_SALE,
  payload: data,
});

export const setMetadata = (data) => ({
  type: AT.SET_MATADATA,
  payload: data,
});